module.exports = __webpack_public_path__ + "img/itunes-note.9d02de7a.svg";